// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GGAO_","left":"styles_left__2kfdU"};